import Dialog from './view.vue';

let instance = null;

export default {
    install(Vue) {
        const SubDialog = Vue.extend(Dialog);

        Vue.prototype.$appointDialog = function (options) {
            if (instance) return;

            return new Promise((resolve, reject) => {
                let mount = null;
                const propsData = {
                    type: options.type,
                    content: options.content,
                    btnText: options.btnText,
                };
                if (options.hasOwnProperty('background')) {
                    propsData.background = options.background;
                }
                const close = () => {
                    instance.$destroy();
                    mount.$el.remove();
                    instance = null;
                }
                instance = new SubDialog({
                    propsData,
                    methods: {
                        cancel() {
                            instance.$destroy();
                            mount.$el.remove();
                            instance = null;
                            reject();
                        },

                        confirm() {
                            if (options.customClose) {
                                resolve(close);
                            } else {
                                instance.$destroy();
                                mount.$el.remove();
                                instance = null;
                                resolve();
                            }
                        }
                    }
                });

                mount = instance.$mount();

                document.body.appendChild(mount.$el)
            })
        }
    }
}